import { NextPageContextEnhanced } from "../../types/page";

export function applyHostDomain(context: NextPageContextEnhanced) {
  const {
    originalUrl,
    host,
    protocol,
    hostNoSubDomain,
    requestUri,
    isLandingRequest,
    isRequestClosed,
    requestPathname,
    requestSearch,
    isDeepLink,
    lang,
    lang2,
    query,
    cookies,
    countryCode,
    isUserLocationCountryAllowed,
    isChangeCountryPage,
    userAgent,
    userIP,
  } = context.req.customContext;
  context.originalUrl = decodeURI(originalUrl || "ar");
  context.lang = lang;
  context.lang2 = lang2;
  context.protocol = protocol as "http" | "https";
  context.hostNoSubDomain = hostNoSubDomain;
  context.host = host;
  context.requestSearch = requestSearch;
  context.requestPathname = requestPathname;
  context.requestUri = requestUri;
  context.isLandingRequest = isLandingRequest;
  context.isRequestClosed = isRequestClosed;
  context.isDeepLink = isDeepLink;
  context.query = { ...(context.query || {}), ...(query || {}) };//merge context query with express query
  context.cookies = cookies || {};
  context.countryCode = countryCode || 'jo';
  context.isUserLocationCountryAllowed = isUserLocationCountryAllowed;
  context.isChangeCountryPage = isChangeCountryPage;
  context.originalUrl = context.originalUrl.replace(
    /https?:\/\/localhost:?(\d+)?/,
    ""
  );

  context.userAgent = userAgent ||"unknonw-user-agent";
  context.userIP = userIP ||"unknonw-user-agent";
  context.ipCountryCode = context.req.customContext.ipCountryCode;
  context.memoryCache = context.req.customContext.memoryCache || {};
  context.logger = context.req.customContext.logger || {};



}
